var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.parsedAddress)?_c('table',{staticClass:"mt-2"},[_vm._l((_vm.parsedAddress),function(value,key){return [(value)?_c('tr',[_c('td',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.addressKeyTitle[key])+":")]),_vm._v(" "),_c('td',{staticClass:"font-weight-semi-bold pl-1"},[_vm._v(_vm._s(value))])]):_vm._e()]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }